export const CONFIG_SERVICE_READ = 'read';
export const CONFIG_SERVICE_RECEIVE = 'receive';

export const LEVERS_CONFIG_KEY_OVERRIDE = 'override';
export const LEVERS_CONFIG_KEY_CACHED = 'cached';
export const LEVERS_CONFIG_KEY_STORED = 'stored';
export const LEVERS_CONFIG_KEY_FALLBACK = 'fallback';
export const LEVERS_CONFIG_KEY_LOCKS = 'locks';

export const LEVER_PID_OVERRIDE = 'override';
export const LEVER_PID_FALLBACK = 'fallback';

export const LEVER_TYPE_BOOLEAN = 'boolean';
export const LEVER_TYPE_NUMBER = 'number';
export const LEVER_TYPE_STRING = 'string';

export const SCHEDULED_UPDATE_TIMEOUT_MS = 1;

export const PERSIST_LEVERS_DEBOUNCE_MS = 500;
export const PERSIST_LEVERS_MAX_WAIT_MS = 5000;

export const KEY_CONFIG_SERVICE_PERSIST = 'TinderWeb/ConfigService';
export const KEY_CONFIG_SERVICE_PERSIST_OVERRIDE = 'TinderWeb/ConfigServiceOverrides';
